import OrganizationManagersPage from './OrganizationManagersPage';

export default OrganizationManagersPage;
